<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/homePage' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>合同列表</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.project_name" autocomplete="off" placeholder="请输入项目名称" clearable
							@change="searchChange" @clear="clearInput(searchForm.project_name)" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.first_party_name" autocomplete="off" placeholder="请输入甲方名称"
							clearable @change="searchChange" @clear="clearInput(searchForm.first_party_name)" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.csm" autocomplete="off" placeholder="请输入经理名称" clearable
							@change="searchChange" @clear="clearInput(searchForm.csm)" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button type="primary" icon="el-icon-search" @click="searchChange"
							size="small">搜索</el-button>
						<el-button icon="el-icon-plus" type="success" @click="handleNewAdd"
							size="small">新增合同</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="medium"
			:default-sort="{ prop: 'id', order: 'descending' }"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="contract_id" label="合同编号" align="center" width="150"/>
			<el-table-column prop="project_name" label="项目名称" align="center" />
			<el-table-column prop="first_party_name" label="甲方" align="center" />
			<el-table-column prop="csm" label="经理" align="center" />
			<el-table-column prop="total_amount" label="总金额" align="center" />
			<el-table-column prop="start_date" label="开始时间" align="center" />
			<el-table-column prop="end_date" label="结束时间" align="center" />
			<el-table-column prop="remark" label="备注" align="center" />
			<el-table-column fixed="right" label="操作" align="center" width="260">
				<template slot-scope="scope">
					<el-button @click.native.prevent="showHt(scope.row)" type="info" size="small">
						详情
					</el-button>
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row.id,scope.row)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.size"
			@pagination="initList" />
		<!-- 添加和修改弹窗 -->
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="65%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="120px" :rules="rules" show-message>
				<el-row>
					<el-col :span="24">
						<el-form-item label="项目名称" prop="xiaoqu_id">
							<el-select v-model="form.xiaoqu_id" placeholder="请输入项目名称" clearable filterable @change="xqChange"
								style="width: 100%">
								<el-option v-for="(item,index) in xqListData" :key="index"
									:label="item.v" :value="item.k" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="甲方名称" prop="company_id">
							<el-select v-model="form.company_id" placeholder="请输入甲方名称" clearable filterable @change="companyChange"
								style="width: 100%">
								<el-option v-for="(item,index) in companyListData" :key="index"
									:label="item.v" :value="item.k" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="经理" prop="staff_id">
							<el-select v-model="form.staff_id" placeholder="请输入经理名称" clearable filterable @change="staffChange"
								style="width: 100%">
								<el-option v-for="(item,index) in gwListData" :key="index"
									:label="item.v" :value="item.k" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="合同时间" prop="htDate">
							<el-date-picker v-model="form.htDate" value-format="yyyy-MM-dd" type="daterange"
								align="right" unlink-panels range-separator="至" start-placeholder="开始时间"
								end-placeholder="结束时间" style="width: 100%" @change="changeDate">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注">
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容"
								v-model="form.remark" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="总金额" prop="total_amount">
							<el-input v-model="form.total_amount" autocomplete="off" placeholder="请输入" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-divider></el-divider>
						<el-form-item label="" v-for="(item, index) in form.node_list" :key="index">
							<el-row>
								<el-col :span="7"><el-input v-model="item.payment_name" autocomplete="off"
										placeholder="请输入款项名称" @input="changeDate" /></el-col>
								<el-col :span="7"><el-input v-model="item.amount" autocomplete="off"
										placeholder="请输入款项金额" @input="changeDate" /></el-col>
								<el-col :span="7"><el-date-picker v-model="item.payment_date" value-format="yyyy-MM-dd"
										type="date" placeholder="选择日期时间" style="width: 100%" @input="changeDate">
									</el-date-picker></el-col>
								<el-col :span="3"><el-button v-if="title != '详情'" @click="nodeDel(item)" type="danger"
										icon="el-icon-delete"></el-button></el-col>
							</el-row>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="title != '详情'">
						<el-form-item>
							<el-button @click="nodeAdd" type="primary" icon="el-icon-plus">节点</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" v-if="title != '详情'" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		htList,
		htAdd,
		htEdit,
		htDel,
		xqList,
		companyList,
		gwList
	} from "../../api/hetong";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: htList,
					add: htAdd,
					del: htDel,
					edit: htEdit,
				},
				// 规则验证
				rules: {
					xiaoqu_id: [{
						required: true,
						message: "请选择项目",
						trigger: "change"
					}, ],
					company_id: [{
						required: true,
						message: "请选择甲方",
						trigger: "change"
					}, ],
					staff_id: [{
						required: true,
						message: "请选择经理",
						trigger: "change"
					}],
					htDate: [{
						required: true,
						message: "请选择合同时间",
						trigger: "change"
					}],
					total_amount: [{
						required: true,
						message: "请输入合同总金额",
						trigger: "blur",
						pattern: /^\d+$/,
					}],
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					size: 15,
					project_name: '',
					first_party_name: '',
					csm: ''
				},
				// 弹窗显隐
				appOpen: false,
				xqListData: [],
				companyListData: [],
				gwListData: []
			};
		},
		mounted() {
			xqList().then(res=>{
				if (res.code == 200) {
					this.xqListData = res.data;
				}
			});
			companyList().then(res=>{
				if (res.code == 200) {
					this.companyListData = res.data;
				}
			});
			gwList().then(res=>{
				if (res.code == 200) {
					this.gwListData = res.data;
				}
			});
		},
		methods: {
			xqChange(e) {
				let xq = this.xqListData.find(item => item.k == e);
				this.form.project_name = xq.v;
			},
			companyChange(e) {
				let company = this.companyListData.find(item => item.k == e);
				this.form.first_party_name = company.v;
			},
			staffChange(e) {
				let staff = this.gwListData.find(item => item.k == e);
				this.form.csm = staff.v;
			},
			searchChange() {
				this.initList();
			},
			// 点击清空事件
			clearInput(item) {
				item = '';
				this.initList();
			},
			singleDel(id, row) {
				this.$confirm(`确定删除合同?`, `删除${row.project_name}合同`, {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(async () => {
					const res = await htDel(id);
					if (res.code !== 200) return this.$message.error("操作失败");
					this.$message.success(`${row.project_name}删除成功!`);
					this.initList();
				});
			},
			nodeDel(node) {
				this.form.node_list = this.form.node_list.filter(item => item.payment_name != node.payment_name);
				this.$forceUpdate();
			},
			nodeAdd() {
				let node = {
					payment_name: '',
					amount: 0,
					payment_date: ''
				}
				if (!this.form.node_list) {
					this.form.node_list = [];
				}
				this.form.node_list.unshift(node);
				this.$forceUpdate();
			},
			changeDate() {
				this.$forceUpdate()
			},
			// 点击确定
			submitForms() {
				if (this.form.htDate && this.form.htDate.length) {
					this.form.start_date = this.form.htDate[0];
					this.form.end_date = this.form.htDate[1];
				}

				this.submitForm();
			},
			// 重置
			reset() {
				this.form = {};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.handleAdd();
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				this.form.xiaoqu_id = this.form.xiaoqu_id.toString();
				this.form.company_id = this.form.company_id.toString();
				this.form.staff_id = this.form.staff_id.toString();
				if (this.form.start_date && this.form.end_date) {
					this.form.htDate = [this.form.start_date, this.form.end_date];
				}

				this.handleEdit();
			},
			// 合同详情
			showHt(row) {
				this.title = "详情";
				this.form = JSON.parse(JSON.stringify(row));

				if (this.form.start_date && this.form.end_date) {
					this.form.htDate = [this.form.start_date, this.form.end_date];
				}

				this.handleEdit();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
			},
		},
	};
</script>

<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	.chooseImg {
		display: flex;
		align-items: center;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	/deep/ .el-dialog__body {
		height: 65vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/hetong/hetonglist.vue